var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9912 22.7422C18.9746 22.7422 23.0879 18.6289 23.0879 13.6543C23.0879 8.67969 18.9658 4.56641 13.9824 4.56641C9.00781 4.56641 4.90332 8.67969 4.90332 13.6543C4.90332 18.6289 9.0166 22.7422 13.9912 22.7422ZM13.9824 15.0869C12.2598 15.0781 10.9238 13.6367 10.9238 11.7295C10.9062 9.93652 12.2686 8.44238 13.9824 8.44238C15.6963 8.44238 17.041 9.93652 17.041 11.7295C17.041 13.6367 15.7051 15.1045 13.9824 15.0869ZM13.9824 21.2393C12.0137 21.2393 9.92188 20.4219 8.59473 18.998C9.60547 17.4863 11.6094 16.6074 13.9824 16.6074C16.3291 16.6074 18.3506 17.4688 19.3701 18.998C18.043 20.4219 15.9512 21.2393 13.9824 21.2393Z",
    fill: "#0B2878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.ac71efc995d4d35e8614c63affa36e64.svg";
export { ForwardRef as ReactComponent };